import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Andrew/subs.vtt';
import poster from '@/static/assets/reviews/Andrew/video.jpg';

export const Andrew: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Andrew',
  videoUrl: `${ASSETS_URL}/car/Andrew.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
